import { z } from 'zod'

import { TemplateInstallRequestSchema, TemplateInstallationMapSchema } from '../botTemplate/schema'

import { InvalidLinkErrorSchema } from './errors'

const StoreTemplateResponseSchema = z.object({
  template: z.object({
    template_id: z.number(),
    title: z.string(),
    subtitle: z.string(),
    description: z.string(),
    authors: z.string(),
    instruction: z.string(),
    cover_url: z.string(),
    video_url: z.string().nullable(),
    live_demo_url: z.string(),
    screenshots: z.array(z.string()),
    integrations: z.array(z.number()),
    categories: z.array(z.number()),
    pro_status: z.number(),
    internal_template_data: z.object({
      image: z.object({
        avatar_url: z.string().nullable(),
        color: z.string(),
      }),
      current_version: z.object({
        structure: z.array(z.string()),
        map: TemplateInstallationMapSchema,
      }),
    }),
    ts_version_updated: z.number(),
  }),
})

export const storeTemplateSchemas = {
  getStoreTemplate: {
    path: z.undefined(),
    query: z.object({
      template_id: z.string(),
    }),
    request: z.undefined(),
    response: StoreTemplateResponseSchema,
    errors: {
      InvalidLinkError: InvalidLinkErrorSchema,
    },
  },
  installStoreTemplate: {
    path: z.object({
      template_id: z.number(),
    }),
    query: z.undefined(),
    request: TemplateInstallRequestSchema.extend({
      quick_campaign_id: z.number().optional(),
    }),
    response: z.object({
      async: z.string(),
    }),
    errors: {
      InvalidLinkError: InvalidLinkErrorSchema,
    },
  },
}

export type StoreTemplateResponse = z.infer<typeof StoreTemplateResponseSchema>
